export default "/_next/static/images/30daa964000b8b43d340ec55a4e82065.jpg";